import React from 'react'

const PageLoader = () => {
  return (
    <div className='w-screen h-screen flex justify-center items-center'>
      {/* Page loader */}
        <span className='page-loader'></span>
    </div>
  )
}

export default PageLoader